<form novalidate (ngSubmit)="save()" #formPetDental="ngForm">
    <div class="card-body mx-0 pt-4">
        <div class="row">
            <div class="col-lg-3 separator-vertical my-0">
                <div class="form-group">
                    <h6>Patient Vital</h6>
                </div>

                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td class="form-label-sm">Respiration <small>Rate/Min</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag3"
                                    [(ngModel)]="petService.pet_vitals.tag3" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Heart <small>Rate/Min</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag4"
                                    [(ngModel)]="petService.pet_vitals.tag4" />
                            </td>
                        </tr>
                        
                        <tr>
                            <td class="form-label-sm">Temperature:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag2"
                                    [(ngModel)]="petService.pet_vitals.tag2" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">SpO<sub>2</sub>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag31"
                                    [(ngModel)]="petService.pet_vitals.tag31" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">ETCO<sub>2</sub>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag32"
                                    [(ngModel)]="petService.pet_vitals.tag32" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">BP <br><small>Sys/Dia (mm Hg)</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag5"
                                    [(ngModel)]="petService.pet_vitals.tag5" />
                            </td>
                        </tr>
                    </tbody>
                </table>
               <hr>
               <div class="form-group">
                    <h6>Subjective</h6>
                </div>

                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td class="form-label-sm">Hydration:</td>
                            <td>
                                <select class="form-control form-select-sm" name="_tag29" [(ngModel)]="petService.pet_vitals.tag29" >
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of HYDRATION">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Lung Sound:</td>
                            <td>
                                <select class="form-control form-select-sm" name="_tag32" [(ngModel)]="petService.pet_vitals.tag32">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of LUNG_SOUNDS">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Heart Sound:</td>
                            <td>
                                <select class="form-control form-select-sm" name="_tag33" [(ngModel)]="petService.pet_vitals.tag33">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of HEARTH_SOUNDS">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-9 my-0">
                <div class="row">
                    <div class="col-lg-7 separator-vertical">
                        <div class="form-group">
                            <h6>Anesthesia/Support</h6>
                        </div>
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <td class="form-label-sm" style="width: 20%;">Start Time:</td>
                                    <td style="width: 40%;">
                                        <input type="time" class="form-control form-control-sm" name="_tag46" [(ngModel)]="petService.pet_vitals.tag46" />
                                    </td>

                                    <td style="width: 40%;"></td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">End Time:</td>
                                    <td>
                                        <input type="time" class="form-control form-control-sm" name="_tag47" [(ngModel)]="petService.pet_vitals.tag47" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Induction:</td>
                                    <td>
                                        <select class="form-control form-select-sm" name="_tag27" [(ngModel)]="petService.pet_vitals.tag27">
                                            <option value=""></option>
                                            <option [value]="item.description" *ngFor="let item of MONITOR_ANES">
                                                {{ item.description }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Amt <small> (mls)</small>:</span>
                                            </div>
                                        <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag27bis"
                                           />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Breathing:</td>
                                    <td>
                                        <select class="form-control form-select-sm" name="_tag28" [(ngModel)]="petService.pet_vitals.tag28">
                                            <option value=""></option>
                                            <option [value]="item.description" *ngFor="let item of MONITOR_BREATH">
                                                {{ item.description }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                      
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Gas:</td>
                                    <td>
                                        <select class="form-control form-select-sm">
                                            <option value=""></option>
                                            <option [value]="item.description" *ngFor="let item of MONITOR_ANES">
                                                {{ item.description }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Rate:</span>
                                            </div>
                                        <input type="text" class="form-control form-control-sm" autocomplete="off"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Fluids:</td>
                                    <td>
                                        <select class="form-control form-select-sm" name="_tag27" [(ngModel)]="petService.pet_vitals.tag27">
                                            <option value=""></option>
                                            <option [value]="item.description" *ngFor="let item of MONITOR_FLUIDS">
                                                {{ item.description }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Rate:</span>
                                            </div>
                                        <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag27bis"
                                            [(ngModel)]="petService.pet_vitals.tag27bis" />
                                        </div>
                                    </td>
                                </tr>            
                            </tbody>
                        </table>
                    </div>
                    <div class="col-lg-5">
                        <div class="form-group">
                            <h6>Procedure</h6>
                        </div>
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <td class="form-label-sm" style="width: 20%;">Procedure:</td>
                                    <td style="width: 80%;">
                                        <select class="form-control form-select-sm" autocomplete="off" name="_tag40"
                                        [(ngModel)]="petService.pet_vitals.tag40">
                                        <option value=""></option>
                                        <option [value]="item.code_name" *ngFor="let item of catalogService.dental_code">
                                            {{ item.code_name }}
                                        </option>
                                    </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Start Time:</td>
                                    <td>
                                        <input type="time" class="form-control form-control-sm" autocomplete="off" name="_tag41"
                                            [(ngModel)]="petService.pet_vitals.tag41" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">End Time:</td>
                                    <td>
                                        <input type="time" class="form-control form-control-sm" autocomplete="off" name="_tag42"
                                            [(ngModel)]="petService.pet_vitals.tag42" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Suture:</td>
                                    <td>
                                        <select class="form-control form-select-sm" autocomplete="off" name="_tag43"
                                        [(ngModel)]="petService.pet_vitals.tag43">
                                        <option value=""></option>
                                        <option [value]="item.item_code" *ngFor="let item of catalogService.suture_codes">
                                           {{ item.item_desc }}
                                        </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Other:</td>
                                    <td>
                                        <select class="form-control form-select-sm" autocomplete="off" name="_tag44"
                                            [(ngModel)]="petService.pet_vitals.tag44">
                                            <option value=""></option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="col-lg-12">
                        <hr>
                        <div class="form-group">
                            <h6>Indices</h6>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <table class="table table-sm">
                            <tbody>
                                <tr>
                                    <td class="form-label-sm">Perio:</td>
                                    <td>
                                        <select class="form-control form-select-sm" [(ngModel)]="petService.pet_dental.perio"
                                        name="_perio" required>
                                        <option value=""></option>
                                        <option [value]="item.problem_index" *ngFor="let item of filterCatalog(101, 199)">
                                            {{ item.problem_name }}
                                        </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                   <td class="form-label-sm">Plaque:</td>
                                   <td>
                                    <select class="form-control form-select-sm" [(ngModel)]="petService.pet_dental.plaque"
                                      name="_plaque" required>
                                    <option value=""></option>
                                    <option [value]="item.problem_index" *ngFor="let item of filterCatalog(201, 299)">
                                    {{ item.problem_name }}
                                    </option>
                                    </select>
                                   </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-lg-6">
                        <table class="table table-sm">
                            <tbody>
                                <tr>                                
                                    <td class="form-label-sm">Calculus:</td>
                                    <td>
                                    <select class="form-control form-select-sm" [(ngModel)]="petService.pet_dental.calc"
                                    name="_calc" required>
                                    <option value=""></option>
                                    <option [value]="item.problem_index" *ngFor="let item of filterCatalog(301, 399)">
                                        {{ item.problem_name }}
                                    </option>
                                   </select>
                                   </td>
                                </tr>
                                <tr>
                                    <td class="form-label-sm">Bleeding:</td>
                                    <td>
                                    <select class="form-control form-select-sm" [(ngModel)]="petService.pet_dental.bleed"
                                        name="_bleed" required>
                                        <option value=""></option>
                                        <option [value]="item.problem_index" *ngFor="let item of filterCatalog(401, 499)">
                                            {{ item.problem_name }}
                                        </option>
                                    </select>
                                    </td>
                                </tr>
                               
                            </tbody>
                        </table>
                    </div>
                    <div class="col-lg-12">
                        <hr>
                        <div class="d-flex align-items-center gap-2 mb-2" style="gap: 1rem;">
                            <h6 class="mb-0 me-2 flex-shrink-0" style="font-size: 1rem;">Oclussion Classifications</h6>
                            <select 
                                class="form-control form-select-sm flex-grow-1 mx-2" 
                                [(ngModel)]="petService.pet_dental.occlusion"
                                name="_occlusion"
                                style="min-width: 0;">
                                <option value=""></option>
                                <option [value]="item.problem_index" *ngFor="let item of filterCatalog(800, 899)">
                                    {{ item.problem_name }}
                                </option>
                            </select>
                            <button type="button" class="btn btn-primary ms-2 flex-shrink-0" (click)="save()">
                                <i class="las la-tooth"></i>
                                Save Changes
                            </button>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <hr>
            </div>
            <div class="col-lg-4 mb-0"> 
                <div class="row">
                    <div class="col-lg-12 mb-2">
                        <h6>Select Teeth Size</h6>
                        <select class="form-control form-select-sm" placeholder="Select Tooth" name="_tooth_no"
                            required [(ngModel)]="selectedTeethType"
                            (change)="onselectTeethDD()"
                            >
                            <option value="" ></option> 
                            <option *ngFor="let item of tooth_option" [value]="item.code">{{item.desc}}</option> 
                        </select>      
                    </div>
                    <div class="col-lg-12">
                      <ngx-svg-maps (pathClickedValue)="handlePathClickValue($event)" ></ngx-svg-maps>
                    </div>
               </div>
            </div>
            <div class="col-lg-8">

                <form novalidate (ngSubmit)="add()" #formClientInfo="ngForm">
                    <div class="table-responsive max-h-500px">
                        <table class="table table-bordered  table-sm" >
                            <thead class="thead-light">
                                <tr>
                                    <th>Tooth</th>
                                    <th>
                                        Category
                                    </th>
                                    <th>
                                        Problem
                                    </th>
                                    <th class="text-center min-w-50px"></th>
                                </tr>
                            </thead>
                            <tbody> 
                                <tr  *ngFor="let item of petService.pet_dental.tooth_problem; let i = index">
                                    <td>{{ item.tooth_no }}</td>
                                    <td>{{ item.category_name }}</td>
                                    <td>{{ item.problem_name }}</td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-icon btn-danger btn-sm" 
                                        (click)="delete(i)">
                                        <i class="fas fa-trash icon-sm"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td><select class="form-control form-select-sm" placeholder="Select Tooth" name="_tooth_no"
                                        required [(ngModel)]="petService.pet_tooth.tooth_no" (change)='onSelectedTeethArea()'>
                                        <option value=""></option>

                                        <ng-container *ngIf="petService.pet_teeth.dog">
                                            <option [value]="item" *ngFor="let item of dogteethlist" >
                                                {{ item }}
                                            </option>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="petService.pet_teeth.puppy">
                                            <option [value]="item" *ngFor="let item of puppyteethlist" >
                                                {{ item }}
                                            </option>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="petService.pet_teeth.kitten">
                                            <option [value]="item" *ngFor="let item of kittennteethlist" >
                                                {{ item }}
                                            </option>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="petService.pet_teeth.cat">
                                            <option [value]="item" *ngFor="let item of catteethlist" >
                                                {{ item }}
                                            </option>
                                        </ng-container>
                                    </select>
                                    </td>
                                    <td>
                                        <select class="form-control form-select-sm" (change)="problem($event)"
                                        name="_category_index" required [(ngModel)]="petService.pet_tooth.category_index">
                                        <option value=""></option>
                                        <option [value]="item.problem_index" *ngFor="let item of filterCatalog(1, 5)">
                                            {{ item.problem_name }}
                                        </option>
                                        </select>
                                    </td>
                                    <td>
                                        <select class="form-control form-select-sm" name="_problem_index" required
                                        [(ngModel)]="petService.pet_tooth.problem_index">
                                        <option value=""></option>
                                        <option [value]="item.problem_index"
                                            *ngFor="let item of filterCatalog(first_index, last_index)">
                                            {{ item.problem_name }}
                                        </option>
                                        </select>
                                    </td>
                                    
                                    <td class="text-center">
                                        <button type="submit" class="btn  btn-icon btn-sm btn-success mt-1" 
                                [disabled]="formClientInfo.invalid">
                                <i class="fas fa-plus icon-sm"></i>
                            </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </form> 

            </div>
        </div>
    </div>


    <!-- <div class="col-lg-12 my-2 separator separator-dashed"></div>
 
    <div class="card-body mt-0 pt-2 mb-0" id="tableToothProblem">
        <form novalidate (ngSubmit)="add()" #formClientInfo="ngForm">
            <div class="table-responsive max-h-500px">
                <table class="table table-bordered  table-sm rounded" >
                    <thead class="thead-light">
                        <tr>
                            <th>Tooth</th>
                            <th>
                                Category
                            </th>
                            <th>
                                Problem
                            </th>
                            <th>
                                Code
                            </th>
                            <th class="text-center min-w-50px"></th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr  *ngFor="let item of petService.pet_dental.tooth_problem; let i = index">
                            <td>{{ item.tooth_no }}</td>
                            <td>{{ item.category_name }}</td>
                            <td>{{ item.problem_name }}</td>
                            <td>{{ item.code_name }}</td>
                            <td class="text-center">
                                <button type="button" class="btn btn-icon btn-danger btn-sm" 
                                (click)="delete(i)">
                                <i class="fas fa-trash icon-sm"></i>
                                 </button>
                            </td>
                        </tr>
                        <tr>
                            <td><select class="form-control" placeholder="Select Tooth" name="_tooth_no"
                                required [(ngModel)]="petService.pet_tooth.tooth_no" (change)='onSelectedTeethArea()'>
                                <option value=""></option>

                                <ng-container *ngIf="petService.pet_teeth.dog">
                                    <option [value]="item" *ngFor="let item of dogteethlist" >
                                        {{ item }}
                                    </option>
                                </ng-container>
                                
                                <ng-container *ngIf="petService.pet_teeth.puppy">
                                    <option [value]="item" *ngFor="let item of puppyteethlist" >
                                        {{ item }}
                                    </option>
                                </ng-container>
                                
                                <ng-container *ngIf="petService.pet_teeth.kitten">
                                    <option [value]="item" *ngFor="let item of kittennteethlist" >
                                        {{ item }}
                                    </option>
                                </ng-container>
                                
                                <ng-container *ngIf="petService.pet_teeth.cat">
                                    <option [value]="item" *ngFor="let item of catteethlist" >
                                        {{ item }}
                                    </option>
                                </ng-container>
                            </select>
                            </td>
                            <td>
                                <select class="form-control" (change)="problem($event)"
                                name="_category_index" required [(ngModel)]="petService.pet_tooth.category_index">
                                <option value=""></option>
                                <option [value]="item.problem_index" *ngFor="let item of filterCatalog(1, 5)">
                                    {{ item.problem_name }}
                                </option>
                                </select>
                            </td>
                            <td>
                                <select class="form-control" name="_problem_index" required
                                [(ngModel)]="petService.pet_tooth.problem_index">
                                <option value=""></option>
                                <option [value]="item.problem_index"
                                    *ngFor="let item of filterCatalog(first_index, last_index)">
                                    {{ item.problem_name }}
                                </option>
                                </select>
                            </td>
                            <td>
                            <select class="form-control" name="_code_no"
                            [(ngModel)]="petService.pet_tooth.code_no">
                            <option value=""></option>
                            <option [value]="item.code_no" *ngFor="let item of catalogService.dental_code">
                                {{ item.code_name }}
                            </option>
                            </select>
                            </td>
                            <td class="text-center">
                                <button type="submit" class="btn  btn-icon btn-sm btn-success mt-1" 
                        [disabled]="formClientInfo.invalid">
                        <i class="fas fa-plus icon-sm"></i>
                    </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form> 
    </div> -->

    <!-- <div class="card-footer text-right py-4">

        <button type="submit" class="btn btn-primary"> 
            Save Changes
        </button>
    </div> -->
</form>


